import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

export type StyledCheckboxProps = {
  disabled?: boolean;
  checked?: boolean;
  isCheckIcon?: boolean;
  isPermissions?: boolean;
  margin?: string;
  hasBorderContainer?: boolean;
};

export type LabelProps = {
  disabled?: boolean;
};

const Wrapper = styled.div<StyledCheckboxProps>`
  display: flex;
  align-items: center;

  ${({ isPermissions }) =>
    isPermissions &&
    css`
      flex-basis: 48%;
    `}

  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

const Label = styled.label`
  min-width: 12rem;
  padding: 1rem 2rem 1rem 0;

  text-transform: uppercase;
  font-family: 'LFT Zeno Condensed', sans-serif;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.1rem;

  cursor: pointer;
`;

const ItemLabel = styled.label<LabelProps>`
  padding-top: 0.2rem;

  font-size: 1.2rem;

  margin-left: 0.5rem;

  color: ${({ disabled }) => (!disabled ? pickColor('black') : pickColor('grayDisabled'))};
`;

const ItemWrapper = styled.div<StyledCheckboxProps>`
  display: flex;
  align-items: center;
  gap: ${({ isCheckIcon }) => (isCheckIcon ? '2rem' : '.8rem')};

  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};

  ${({ hasBorderContainer, disabled }) =>
    hasBorderContainer &&
    disabled &&
    css`
      background-color: ${pickColor('restTabBackground')};
      color: ${pickColor('restTabText')};
    `}

  &:not(:last-child) {
    margin-right: 2rem;
  }
`;

const InputWrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })<StyledCheckboxProps>`
  ${({ isCheckIcon, checked }) =>
    isCheckIcon
      ? css`
          position: absolute;
          top: 0;
          left: 0;

          width: 1.6rem;
          height: 1.6rem;

          opacity: 0;

          cursor: pointer;
        `
      : css`
          display: inline-flex;
          -webkit-appearance: none;

          width: 1.6rem;
          height: 1.6rem;

          border: 0.2rem solid ${pickColor('colmarBlue')};
          border-radius: ${({ theme }) => theme.borderRadius.base};
          background: ${pickColor('white')};

          transition: background-color 200ms ease-in;

          cursor: pointer;

          &:after {
            display: block;

            width: 100%;
            padding: 0.1rem;

            content: '';

            transition: 200ms ease-in-out;

            background-color: ${pickColor('colmarBlueTransparent')};
          }

          ${checked
            ? css`
                &:after {
                  background-color: ${pickColor('colmarBlue')};
                }
              `
            : null}

          &:disabled {
            background-color: ${pickColor('grayTertiary')};
            border-color: ${pickColor('grayDisabled')};

            cursor: not-allowed;
          }

          &:disabled:after {
            background-color: ${pickColor('grayTertiary')};
          }
        `}
`;

export { Wrapper, ItemWrapper, ItemLabel, Label, InputWrapper, Checkbox };
